export default {"src":"/_next/static/media/convex.abc7d47b.svg","height":125,"width":122,"blurWidth":0,"blurHeight":0};